import { AudioEventHandlers } from '../ts/types';
import { AudioEventType } from '../ts/enums';

export const attachAudioEvents = (
  audioElement: HTMLAudioElement,
  timelineElement: HTMLInputElement,
  handlers: AudioEventHandlers,
): (() => void) => {
  const {
    handleCanPlay,
    handleWaiting,
    updateTimelineProgress,
    handleAudioEnded,
    handleSeekChange,
  } = handlers;

  // Store event listeners to remove them in cleanup function
  const eventListeners: Array<{
    element: HTMLElement | HTMLAudioElement;
    type: string;
    handler: EventListenerOrEventListenerObject;
  }> = [];

  // Helper to attach and track event listeners
  const attachEvent = (
    element: HTMLElement | HTMLAudioElement,
    type: string,
    handler: EventListenerOrEventListenerObject,
  ) => {
    element.addEventListener(type, handler);
    eventListeners.push({ element, type, handler });
  };

  // Attach audio event listeners
  if (handleCanPlay) {
    attachEvent(audioElement, AudioEventType.CAN_PLAY, handleCanPlay);
  }

  if (handleWaiting) {
    attachEvent(audioElement, AudioEventType.WAITING, handleWaiting);
  }

  if (updateTimelineProgress) {
    attachEvent(audioElement, AudioEventType.TIME_UPDATE, updateTimelineProgress);
  }

  if (handleAudioEnded) {
    attachEvent(audioElement, AudioEventType.ENDED, handleAudioEnded);
  }

  if (handleSeekChange) {
    attachEvent(timelineElement, AudioEventType.INPUT, handleSeekChange);
  }

  // Return cleanup function
  return () => {
    eventListeners.forEach(({ element, type, handler }) => {
      element.removeEventListener(type, handler);
    });
  };
};
